import React, { useEffect } from "react";
import "./style.css";

function TextToQuoteCard() {
  useEffect(() => {
    console.log("Text Card Mounted");
  }, []);

  const redirect = (url) => {
    console.log("redirecting to: " + url);
    window.open(url, "", "width=800, height=800, top=+200, left=+400");
  };

  return (
    <div className="row">
      <div
        className="card col-md-6 offset-md-6 col-sm-8 offset-sm-2 col-xs-10 offset-xs-1"
        style={{
          margin: "10px",
          boxShadow: "0px 0px 1px 1px black",
          borderRadius: "10px",
          padding: "10px",
          color: "black",
          backgroundColor: "white"
        }}
      >
        <div
          className="card-header"
          style={{ textAlign: "center", color: "black", backgroundColor: "orange" }}
        >
          <div className="row">
            <div className="col-md-3">
              <img
                alt="plymouth"
                style={{ height: "100px", width: "200px" }}
                src="/images/plymouth-logo.png"
              />
            </div>
            <div className="col-md-9">
              <h2 style={{ color: "black", marginTop: "25px" }}>
                <strong>Quote in seconds</strong>
              </h2>
            </div>
          </div>
        </div>

        <div
          className="card-body"
          style={{ textAlign: "center", padding: "25px", backgroundColor: "darkorange" }}
        >
          <h3>
            <strong>
              Just text 'Rock' <br /> to 267-609-4721
            </strong>
          </h3>
          <h5>Follow the instructions to get a quote in seconds!</h5>

          <br />
          <p> If you do not want to text for a quote you can get an online quote by going here: </p>
          <button
            className="box-shadow-button"
            style={{
              boxShadow: "0px 0px 2px 2px black",
              borderRadius: "10px",
              height: "50px",
              width: "50%",
              backgroundColor: "black",
              color: "white"
            }}
            onClick={() => redirect("https://nwexpress.com/fawncircle")}
          >
            <div className="row">
              <div className="col-xl-12">
                <h5 style={{ color: "white" }}>
                  <strong>Express Quote</strong>
                </h5>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default TextToQuoteCard;
